import { SuppliesInventoryConfigStatus } from "@redotech/cockroachdb-codegen/tables/supplies-inventory-config-status";
import {
  AccountId,
  accountIdFormat,
  ProductId,
  productIdFormat,
} from "@redotech/redo-ids-cockroach";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const SuppliesInventoryConfigStatusSchema = createEnum(
  SuppliesInventoryConfigStatus,
);

/** How a supplies order is paid. */
//redontIgnore
export enum SuppliesPaymentMethod {
  /** Debited against the merchant's OMS ("outbound-labels") balance ledger. */
  OmsBalance = "oms_balance",
  /** Charged immediately to a saved Stripe payment method (card or ACH). */
  Stripe = "stripe",
}

/**
 * How a supplies order is paid: the OMS balance ledger, or one of the merchant's
 * saved Stripe payment methods (primary/secondary).
 */
export const SuppliesPaymentMethodChoiceSchema = z.discriminatedUnion("kind", [
  z.object({ kind: z.literal(SuppliesPaymentMethod.OmsBalance) }),
  z.object({
    kind: z.literal(SuppliesPaymentMethod.Stripe),
    //redontIgnore
    priority: z.enum(["primary", "secondary"]),
  }),
]);
export type SuppliesPaymentMethodChoice = z.infer<
  typeof SuppliesPaymentMethodChoiceSchema
>;

export enum SuppliesInventoryTrackedProductType {
  LABEL_PAPER = "LABEL_PAPER",
  PARCEL_PACKAGING = "PARCEL_PACKAGING",
}

export function getRedoSuppliesAccountInfo(): {
  accountId: AccountId;
  teamId: string;
} {
  if (process.env.NODE_ENV === "production") {
    return {
      accountId: accountIdFormat.write(BigInt("2209160522559597213")),
      teamId: "69334cb38b62ab405f172655",
    };
  } else {
    return {
      accountId: accountIdFormat.write(
        BigInt(process.env.SUPPLIES_SOURCE_ACCOUNT_ID || ""),
      ),
      teamId: process.env.SUPPLIES_SOURCE_TEAM_ID || "",
    };
  }
}

// These are the supplies products that we sell that are eligible for inventory
// tracking and reordering to be set up
export function getEligibleInventoryTrackedProducts(): {
  eligibleInventoryTrackedProducts: {
    productId: ProductId;
    type: SuppliesInventoryTrackedProductType;
    quantityPerCase: number;
  }[];
} {
  return {
    eligibleInventoryTrackedProducts: [
      {
        productId: productIdFormat.write(BigInt("6956299579183592813")),
        type: SuppliesInventoryTrackedProductType.LABEL_PAPER,
        quantityPerCase: 4000,
      },
    ],
  };
}

export { SuppliesInventoryConfigStatus };
